// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"7ff6efd5","105":"c961a3e2","283":"92221dea","483":"8ad42980","566":"fe09ae61","727":"48233073"}[chunkId] + ".chunk.js";
};